<section appReveal class="ss-section w-full px-4 sm:px-8">
    <div class="ss-grid mx-auto grid w-full max-w-[1200px] gap-10 lg:grid-cols-2 lg:gap-16">

        <!-- Left: heading + intro + eyebrow. -->
        <div class="ss-left r-left flex flex-col">
            <h2 class="ss-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
            @if (bodyLead.length) {
                <div class="ss-prose font-inter space-y-4 mt-6">
                    @for (paragraph of bodyLead; track $index) {
                        <p>{{ paragraph }}</p>
                    }
                </div>
            }
            <p class="ss-eyebrow font-outfit font-bold mt-8">{{ eyebrow }}</p>
        </div>

        <!-- Right: stacked glass cards — term + detail (steps) or single gradient label (bullets). -->
        @if (section.steps?.length) {
            <ul class="ss-steps flex flex-col gap-4">
                @for (step of section.steps; track $index) {
                    <li class="ss-card r-drop" [style.--reveal-delay]="$index * 150 + 'ms'">
                        <span class="ss-term font-outfit font-semibold gradient-text">{{ step.term }}</span>
                        <span class="ss-detail font-inter">{{ step.detail }}</span>
                    </li>
                }
            </ul>
        } @else if (section.bullets?.length) {
            <ul class="ss-steps flex flex-col gap-4">
                @for (bullet of section.bullets; track $index) {
                    <li class="ss-card ss-card-label r-drop" [style.--reveal-delay]="$index * 150 + 'ms'">
                        <span class="ss-term font-outfit font-semibold gradient-text">{{ bullet }}</span>
                    </li>
                }
            </ul>
        }
    </div>

    @if (section.outro?.length) {
        <div class="ss-outro font-inter space-y-4 mt-12 mx-auto max-w-[820px] text-center">
            @for (paragraph of section.outro; track $index) {
                <p>{{ paragraph }}</p>
            }
        </div>
    }
</section>
